import { gql } from '@apollo/client';

export const INVITE_USER = gql`
    mutation InviteUser($contactInput: ContactInput!) {
        inviteUser(contactInput: $contactInput)
    }
`;
